import { setChildren } from 'https://cdn.venturz.co/lib/redom.es.js';

import ModuleBase from '../module-base/index.js';
import ShowMoreControl from './show-more/index.js';

const PAGE_SIZE = 100;

class Directory extends ModuleBase {

  constructor(configuration, page) {

    super(configuration, page);

    this.collectionViewId = this.configuration.collectionViewId;
    this.dataCollectionViewInterfaces = null;
    this.gridApi = null;
    this.loadedCount = 0;
    this.showMoreControl = null;

    this.externalStyleSheets = [
      'https://cdn.jsdelivr.net/npm/ag-grid-community/styles/ag-theme-quartz.css'
    ];

    this.el = document.getElementById(this.configuration.id);
    this.el.classList.add('ag-theme-quartz');

    this.loadMore = this.loadMore.bind(this);

  }

  async setupServerInterfaces() {

    const DataCollectionViewInterfaces = (await import('../api-interface/data-collection-views/index.js')).default;

    const apiInterface = await this.page.getDependency('api-interface');

    this.dataCollectionViewInterfaces = new DataCollectionViewInterfaces(apiInterface.basePath, apiInterface.apiClient);

  }

  fetchRecords(skip) {

    const queryOptions = { paginationOptions: { skip, limit: PAGE_SIZE } };

    return this.dataCollectionViewInterfaces.getDataCollectionViewForEditor(this.collectionViewId, queryOptions);

  }

  toRowData(records) {

    return records.map(function mapper(record) {
      return record.data;
    });

  }

  async initializeGrid(createGrid) {

    const result = await this.fetchRecords(0);
    setChildren(this.el, []);

    const columns = result.view.columns;
    const rowData = this.toRowData(result.records);
    this.loadedCount = rowData.length;

    const pageSize = result.view.pageSize;
    const gridOptions = {
      domLayout: 'autoHeight'
    };

    if (pageSize > 0) {
      gridOptions.pagination = true;
      gridOptions.paginationPageSize = pageSize;
    }

    const grid = await createGrid(this.el, {
      columns,
      rowData,
      serverInterfaces: this.dataCollectionViewInterfaces,
      collectionViewId: this.collectionViewId
    }, gridOptions);

    this.gridApi = grid.api;

    this.setupShowMore(rowData.length);

  }

  setupShowMore(firstPageCount) {

    if (firstPageCount < PAGE_SIZE) {
      return;
    }

    this.showMoreControl = new ShowMoreControl(this.loadMore);
    this.el.insertAdjacentElement('afterend', this.showMoreControl.el);
    this.showMoreControl.setLoadedStatus(this.loadedCount);

  }

  async loadMore() {

    this.showMoreControl.startLoading();

    let result;

    try {
      result = await this.fetchRecords(this.loadedCount);
    } catch (error) {
      this.showMoreControl.showError();
      return;
    }

    const rowData = this.toRowData(result.records);

    if (rowData.length > 0) {
      this.gridApi.applyTransaction({ add: rowData });
      this.loadedCount = this.loadedCount + rowData.length;
    }

    if (rowData.length < PAGE_SIZE) {
      this.showMoreControl.markComplete(this.loadedCount);
    } else {
      this.showMoreControl.stopLoading(this.loadedCount);
    }

  }

  async initialize() {

    const [mod] = await Promise.all([
      import('./grid/index.js'),
      this.setupServerInterfaces()
    ]);

    await this.initializeGrid(mod.createGrid);

  }

}

export default Directory;